import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";

import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";

import { FieldElementBlock } from "../../blocks/shared/components/FieldElementBlock";
import { useBlocksContext } from "../../contexts/BlocksContext";

interface EmailBlockMeta {
  elementableId: number;
  elementId: number;
  fieldIndex: number;
  position: number;
}
export interface FormContactEmailBlockProps extends ComponentPropsWithRef<"div"> {
  blockInstanceMeta?: EmailBlockMeta;
  label?: string;
  placeholder?: string;
}

export const FormContactEmailBlock = forwardRef<
  HTMLDivElement,
  FormContactEmailBlockProps
>(
  (
    {
      label = t("settings.forms.default_contact_email_label"),
      placeholder = "",
      blockInstanceMeta = {},
      ...rest
    },
    ref,
  ) => {
    const { useFormRenderingContext } = useBlocksContext();
    const context = useFormRenderingContext();
    const { currentUser } = usePunditUserContext();

    const shouldPrefillAndDisable =
      !context.isPreview && Boolean(currentUser?.email);

    return (
      <FieldElementBlock
        ref={ref}
        blockInstanceMeta={blockInstanceMeta}
        elementConfig={{ required: true }}
        fieldType="contact_email"
        label={label}
        placeholder={placeholder}
        disabled={shouldPrefillAndDisable}
        fieldDefaultValue={
          shouldPrefillAndDisable ? currentUser?.email : undefined
        }
        {...rest}
      />
    );
  },
);

FormContactEmailBlock.displayName = "FormContactEmailBlock";
